import {ChangeDetectionStrategy, Component, ViewEncapsulation} from '@angular/core';
import {ThemeService} from '@app/services/theme.service';
import {NavigationMenuService} from '@app/services/navigation-menu.service';
import {NavLayoutService} from '@app/services/nav-layout.service';
import {ProjectContextService} from '@app/services/project-context.service';

/**
 * The bar across the top, in two layouts. With the top menu: logo, project switcher, the menu,
 * then the toolbar and account menu - the navbar as it always looked. With the side menu (and
 * on a phone): the breadcrumb takes the menu's place, with a hamburger when the menu is a
 * drawer. The toolbar and account menu are the same in both.
 */
@Component({
  selector: 'app-nav-header',
  templateUrl: './nav-header.component.html',
  styleUrls: ['./nav-header-legacy.scss', './nav-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class NavHeaderComponent {
  readonly layout$ = this.navLayout.state$;
  readonly context$ = this.projectContext.context$;
  readonly crumbs$ = this.menu.breadcrumb$;
  readonly available$ = this.menu.available$;
  readonly isInfluencer$ = this.menu.isInfluencer$;
  readonly isDarkTheme$ = this.themeService.isDarkTheme$;

  constructor(
    private navLayout: NavLayoutService,
    private projectContext: ProjectContextService,
    private menu: NavigationMenuService,
    private themeService: ThemeService,
  ) {
  }

  openDrawer(): void {
    this.navLayout.openDrawer();
  }

  reload(): void {
    window.location.reload();
  }
}
